export default "__VITE_ASSET__cb7deplP__"